import axios, { AxiosError, CancelTokenSource } from 'axios';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { INotfis } from '../../../../../interfaces/response/Notfis/INotfisResponse';
import { postUploadNotfis } from '../../../../../redux/features/orders/ordersThunk';
import { useAsyncDispatch } from '../../../../../redux/store';

export interface UseDragDrop {
  handleChange: (fileAux: File) => void;
  fileTypes: string[];
  file: File | null;
  setFile: Dispatch<SetStateAction<File | null>>;
  handleSend: () => Promise<void>;
  loading: boolean;
}

const useDragDrop = (callback: () => Promise<void>): UseDragDrop => {
  const cancelTokenRef = useRef<CancelTokenSource>();
  const cancelToken = axios.CancelToken;
  const [file, setFile] = useState<File | null>(null);
  const [notfis, setNotfis] = useState<INotfis | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useAsyncDispatch();
  const fileTypes = ['JSON'];

  const handleChange = (fileAux: File): void => {
    setFile(fileAux);
  };

  function lerArquivoJSON(fileRead: File): Promise<INotfis> {
    return new Promise((resolve, reject) => {
      // Criando um FileReader
      const leitor = new FileReader();

      // Configurando o evento de carga do FileReader
      leitor.onload = (evento) => {
        try {
          // Obtendo o resultado do FileReader (conteúdo do arquivo)
          const conteudoArquivo = evento.target?.result as string;
          // Parseando o conteúdo do arquivo para um objeto JSON
          const objetoJSON = JSON.parse(conteudoArquivo);
          // Resolvendo a Promise com o objeto JSON
          resolve(objetoJSON);
        } catch (parseError) {
          // Se ocorrer um erro durante o parsing, rejeita a Promise com o erro de parsing
          reject(parseError);
        }
      };

      // Configurando o evento de erro do FileReader
      leitor.onerror = (evento) => {
        // Rejeitando a Promise com o erro do FileReader
        reject(evento.target?.error);
      };

      // Lendo o conteúdo do arquivo como texto
      leitor.readAsText(fileRead);
    });
  }

  const handleSend = async (): Promise<void> => {
    setLoading(true);
    if (!file) return;

    const source: CancelTokenSource = cancelToken.source();
    cancelTokenRef.current = source;

    lerArquivoJSON(file)
      .then((objetoJSON) => {
        setNotfis(objetoJSON);
      })
      .catch((erro) => {
        setLoading(false);
        return toast.error('Erro ao realizar upload do arquivo');
      });

    if (notfis) {
      await dispatch(postUploadNotfis({ body: notfis, cancelToken: source }))
        .unwrap()
        .then(async (res) => {
          setFile(null);
          toast.success('upload do arquivo realizado com sucesso!');
          await callback();
        })
        .catch((error) => {
          const axiosError = error as AxiosError;
          if (axiosError.code === 'ERR_CANCELED') return;
          console.log(error);

          toast.error(
            error.response?.data?.mensagem ||
              'Erro ao realizar upload do arquivo'
          );
        });
    }
    setLoading(false);
  };

  return {
    file,
    fileTypes,
    handleChange,
    handleSend,
    setFile,
    loading,
  };
};

export default useDragDrop;
